import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/openbox_logo_blue_horizontal.png")